var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeywordRankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_804_2535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5152 15.8492L17.4113 6.73037C16.9873 6.43543 16.4831 6.27734 15.9666 6.27734C15.45 6.27734 14.9459 6.43543 14.5218 6.73037L1.41797 15.8492",
    stroke: "#007C65",
    strokeWidth: 1.01208,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5152 24.7067C30.5152 25.4025 30.0484 25.6467 29.4765 25.2481L17.0052 16.5734C16.6938 16.3787 16.3339 16.2755 15.9666 16.2755C15.5993 16.2755 15.2394 16.3787 14.9279 16.5734L2.45661 25.2456C1.88479 25.6441 1.41797 25.4 1.41797 24.7067V22.809C1.43993 22.4228 1.54392 22.0457 1.72301 21.7028C1.9021 21.3599 2.15219 21.059 2.45661 20.8203L14.9279 12.1455C15.2394 11.9509 15.5993 11.8477 15.9666 11.8477C16.3339 11.8477 16.6938 11.9509 17.0052 12.1455L29.4765 20.8203C29.781 21.059 30.0311 21.3599 30.2101 21.7028C30.3892 22.0457 30.4932 22.4228 30.5152 22.809V24.7067Z",
    stroke: "#007C65",
    strokeWidth: 1.01208,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_804_2535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.3623,
    height: 30.3623,
    fill: "white",
    transform: "translate(0.785156 0.667969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordRankIcon);
export default __webpack_public_path__ + "static/media/keyword-rank-icon.d93f9a28a2bab1fad32d180d3983d8f6.svg";
export { ForwardRef as ReactComponent };